export default __webpack_public_path__ + "static/media/craon10.1a5112af.jpg";